import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", { d: "M10.116 21.75v-6.789H8.23V9.02q0-.745.53-1.276a1.74 1.74 0 0 1 1.278-.531h3.922q.746 0 1.277.53.531.532.531 1.277v5.942h-1.885v6.789zM12 5.904q-.761 0-1.304-.542a1.78 1.78 0 0 1-.542-1.304q0-.762.542-1.304A1.78 1.78 0 0 1 12 2.212q.761 0 1.304.542.542.542.542 1.304 0 .76-.542 1.304A1.78 1.78 0 0 1 12 5.904" }, null, -1)
  ])))
}
export default { render: render }